var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLienExterneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 0h1.6v1.597c0 0.002 0 0.003 0 0.005v20.798c0 0.884-0.717 1.6-1.6 1.6s-1.6-0.716-1.6-1.6v-17.060l-35.479 33.872c-0.639 0.61-1.652 0.587-2.262-0.053s-0.587-1.652 0.052-2.262l35.296-33.697h-16.807c-0.883 0-1.6-0.716-1.6-1.6s0.717-1.6 1.6-1.6h20.8c0 0 0 0 0 0zM32.865 10.508h-32.865v53.492h53.492v-34.595c0-0.884-0.716-1.6-1.6-1.6s-1.6 0.716-1.6 1.6v31.395h-47.092v-47.092h29.665c0.883 0 1.6-0.716 1.6-1.6s-0.717-1.6-1.6-1.6z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLienExterneWhite);
export default __webpack_public_path__ + "static/media/lien-externe-white.253f80da34bdc9849a0acbae51e86f15.svg";
export { ForwardRef as ReactComponent };